import { ResponseDto } from '@r1-frontend/api-domru/dadata/v1/address/check/dto/ResponseDto';

export type TOwnSuggestion = {
    city?: string,
    street?: string,
    house?: string,
    flat?: string,
    ownData: {
        unifiedHouseId?: number,
        houseId?: number,
    },
}

export type TFailedCheckResult = {
    isConnectionAvailable: boolean,
    isTariffAvailableForActivation?: boolean,
    message: string,
}

export type TInitialState = {
    initialized: boolean,
    isLoading: boolean,
    hasError: boolean,

    salePackageId?: number,
    withReissue: boolean,

    address: string,
    suggestionSelected: boolean,

    checkResult: ResponseDto | TFailedCheckResult | null,
}

export const initialState: TInitialState = {
    initialized: false,
    isLoading: false,
    hasError: false,

    salePackageId: undefined,
    withReissue: false,

    address: '',
    suggestionSelected: false,

    checkResult: null,
};
